import React, { useState } from "react";

import Image from "../../../Assets/banner1wp.webp";
import WhyUsSmall from "../../../Assets/Why-Us-SmallImage.jpg";
import WhyUs from "../../../Assets/Why-Us.webp";

import "../Components/WhyUs.css";

import WhyUsIcon1 from "../../../Assets/Icons- plaster.svg";
import WhyUsIcon2 from "../../../Assets/Icons- firstaid.svg";

import WhyUsIcon3 from "../../../Assets/Icons- virus.svg";
import WhyUsIcon4 from "../../../Assets/Icons- medicine-symbol.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";

const WhyUsComponent = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="MainComponent">
      <div className="Newwhy-Us">
        <div className="Newwhy-Us1div">
          <h2>Why Us? </h2>
          <p style={{ marginTop: "20px" }}>
            We are India’s fastest-growing diagnostic service provider, with a
            presence in more than 120 cities. We offer a holistic in-house
            end-to-end solution - Right from the time of receiving a call, to
            the home collection, testing of the sample, generating report and
            mailing it further to the patient, every step is carefully and
            professionally executed by the experienced in-house team. Our
            expertise lies in on-demand 1-hour home collection and same-day
            reports within 24 hours. All our owned pathology labs and diagnostic
            centres are equipped with state-of-the-art infrastructure and
            staffed with a highly trained medical team to meet the testing
            requirements of the patients. Our automated processes ensure minimal
            human interference, which helps maintain a high degree of accuracy
            that leads to better patient diagnosis.
          </p>
        </div>

        <div className="Newwhy-Us2div">
          <div className="whyUssmallImagediv">
            <LazyLoadImage
              src={WhyUsSmall}
              alt="Why-Us-Smallimage"
              delayTime="100"
              className="WhyUssmallImage"
            />
          </div>
          <LazyLoadImage
            src={"https://static.redcliffelabs.com/static/Assets/Why-Us.webp"}
            alt="WhyUsImage"
            delayTime="100"
            className="NewWhyUS-Image"
          />
        </div>

        <div className="Newwhy-Us3div">
          <div className="Newunder-why-Us3div">
            <div className="NewWhyUstwoDiV">
              <div className="NewwhyUSsmalldiv">
                <div className="NewWhyUselogo">
                  <img
                    src={WhyUsIcon4}
                    alt="medical sign"
                    className="why-Us-Icon-size"
                  />
                </div>
                <p className="NewwhyUspara">
                  Widest Network
                  <p className="NewwhyUSspan">of Lab and collection centers</p>
                </p>
              </div>
              <div className="NewwhyUSsmalldiv">
                <span className="NewWhyUselogo">
                  <LazyLoadImage
                    src={WhyUsIcon3}
                    alt="medical sign"
                    delayTime="100"
                    className="why-Us-Icon-size"
                  />
                </span>
                <p className="NewwhyUspara">
                  Genetic Testing
                  <p className="NewwhyUSspan">
                    Next Generation Sequencing (NGS)
                  </p>
                </p>
              </div>
            </div>
            <div className="NewWhyUstwoDiV">
              <div className="NewwhyUSsmalldiv">
                <span className="NewWhyUselogo">
                  <LazyLoadImage
                    src={WhyUsIcon2}
                    alt="medical sign"
                    delayTime="100"
                    className="why-Us-Icon-size"
                  />
                </span>
                <p className="NewwhyUspara">
                  3500+ Tests
                  <p className="NewwhyUSspan">
                    covering all routine & specialized tests
                  </p>
                </p>
              </div>
              <div className="NewwhyUSsmalldiv">
                <span className="NewWhyUselogo">
                  <img
                    src={WhyUsIcon1}
                    alt="medical sign"
                    className="why-Us-Icon-size"
                  />
                </span>
                <p className="NewwhyUspara">
                  Health Packages
                  <p className="NewwhyUSspan">
                    Preventive Health Check Packages
                  </p>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyUsComponent;
